export default [
	{
		description:
			"This app was develop for a company where i&aposm current working Neo Redes, this app is built on Vue JS without backend on NodeJs.  introduccion  of this app. With this application we are looking eliminate the dead times where tecnicians  in this company wait a inggenier from a external companies, this is thanks a one module that i builded  Where the tecnicians check they are in the fail site and they are waiting for this inggeniers, in the same module the tecnicias must take a picture from they arrive, while they are working in the site and when they leave it. also they left a little description, and the left if they have to left components they have a little &quotCRUD&quot where them can add, delete or modify what are that components. The app has more modules but i worked more in this part , in backend and frontend, where backend has a connection with a MongoDB, the frontend was make in VueJS and the UI with Vuetify. It has a automatly functions for check the status of the tickets each day, a excel generator for get the data from the tickets in excel format, web push notifications to alert the tecnicians about their tickets, also checking for each technicians just can see its tickes",
		name_web: "MemoryReports",
		img: "https://pbs.twimg.com/media/EVG0xfuUUAAGFEC.png",
		code: "https://www.google.com",
		website: "https://www.memoryreports.com/login",
		tags: [
			{
				name: "VueJS",
				url: "vue.svg",
				alt: "Vuejs icon",
				url: "https://cdn.svgporn.com/logos/vue.svg",
			},
			{
				name: "Vuetify",
				url: "css-3_official.svg",
				alt: "Vuetify icon",
				url: "https://cdn.svgporn.com/logos/vuetifyjs.svg",
			},
			{
				name: "CSS3",
				url: "css-3_official.svg",
				alt: "CSS icon",
				url: "https://cdn.svgporn.com/logos/css-3.svg",
			},
			{
				name: "PushJS",
				url: "npm.svg",
				alt: "PushJS icon",
				url: "https://pushjs.org/images/logo.svg",
			},
			{
				name: "Json Web Decode",
				url: "npm.svg",
				alt: "Nodemailer icon",
				url: "https://cdn.svgporn.com/logos/npm-icon.svg",
			},
			{
				name: "Leaflet",
				url: "leaflet.svg",
				alt: "Leaflet icon",
				url: "https://cdn.svgporn.com/logos/leaflet.svg",
			},
			{
				name: "Date fns",
				url: "npm.svg",
				alt: "Date fns icon",
				url: "https://cdn.svgporn.com/logos/npm-icon.svg",
			},
			{
				name: "Json-as-xlsx",
				url: "npm.svg",
				alt: "Json-as-xlsx icon",
				url: "https://cdn.svgporn.com/logos/npm-icon.svg",
			},
			{
				name: "Axios",
				url: "npm.svg",
				alt: "Axios icon",
				url: "https://cdn.svgporn.com/logos/axios.svg",
			},
			{
				name: "NodeJS",
				img: "nodejs.svg",
				alt: "NodeJS icon",
				url: "https://cdn.svgporn.com/logos/nodejs-icon.svg",
			},
			{
				name: "NodeMailer",
				img: "npm.svg",
				alt: "Nodemailer icon",
				url: "https://nodemailer.com/nm_logo_200x136.png",
			},
			{
				name: "Jason Web Token",
				img: "npm.svg",
				alt: "Nodemailer icon",
				url: "https://jwt.io/img/logo.svg",
			},
			{
				name: "Morgan",
				img: "npm.svg",
				alt: "Nodemailer icon",
				url: "https://cdn.svgporn.com/logos/npm-icon.svg",
			},
			{
				name: "Express",
				img: "express.svg",
				alt: "Nodemailer icon",
				url: "https://cdn.svgporn.com/logos/express.svg",
			},
			{
				name: "Mongoose",
				img: "npm.svg",
				alt: "Nodemailer icon",
				url: "https://cdn.svgporn.com/logos/npm-icon.svg",
			},
			{
				name: "MongoDB",
				img: "mongodb.svg",
				alt: "Nodemailer icon",
				url: "https://cdn.svgporn.com/logos/mongodb-icon.svg",
			},
			{
				name: "WebPusher",
				img: "npm.svg",
				alt: "Nodemailer icon",
				url: "https://cdn.svgporn.com/logos/npm-icon.svg",
			},
			{
				name: "socket.io",
				img: "npm.svg",
				alt: "Nodemailer icon",
				url: "https://cdn.svgporn.com/logos/socket.io.svg",
			},
		],
		id: 1,
	},
	{
		name_web: "Kodda",
		description:
			"Kodda is a little app to help sell, dog tags, has a backend on node to send automatically a mail to seller",
		img: "https://pixabay.com/get/g53f2fde2282da4fc3e7f9120bac3fc2d68baabf651da727b41032b2967d229dfe0788f109b75dd6c8344d2970e5613fc9c6f7acf90ed1dcb58fe465cb5443867_1280.png",
		code: "https://www.google.com",
		website: "https://kodda-landing.netlify.app/",
		tags: [
			{
				name: "ReactJs",
				img: "https://cdn.svgporn.com/logos/react.svg",
				alt: "ReactJs icon",
				url: "https://cdn.svgporn.com/logos/react.svg",
			},
			{
				name: "CSS",
				img: "https://cdn-icons-png.flaticon.com/512/5968/5968242.png",
				alt: "CSS icon",
				url: "https://cdn.svgporn.com/logos/css-3.svg",
			},
			{
				name: "NodeJS",
				img: "nodejs.svg",
				alt: "NodeJS icon",
				url: "https://cdn.svgporn.com/logos/nodejs-icon.svg",
			},
			{
				name: "NodeMailer",
				img: "npm.svg",
				alt: "Nodemailer icon",
				url: "https://nodemailer.com/nm_logo_200x136.png",
			},
		],
		id: 2,
	},
	{
		name_web: "Prisma Joyeria Landing",
		description:
			"Landing page prisma joyeria, was a frelance project to a jewelry ",
		img: "https://pixabay.com/get/gad2113a7cfd6ee59157d9a9e7b4d8bd66f206b28fca79d131f8ffec3ad0ddda7fcfce9ed0d376fc816846a0c8187f5661e7d9dbb54df6c77b61d5f554eb7cb9d_1280.jpg",
		code: "https://www.google.com",
		website: "https://landing-page-prisma.netlify.app/",
		tags: [
			{
				name: "ReactJs",
				img: "https://cdn.svgporn.com/logos/react.svg",
				alt: "ReactJs icon",
				url: "https://cdn.svgporn.com/logos/react.svg",
			},
			{
				name: "CSS",
				img: "https://cdn-icons-png.flaticon.com/512/5968/5968242.png",
				alt: "CSS icon",
				url: "https://cdn.svgporn.com/logos/css-3.svg",
			},
		],
		id: 3,
	},
	{
		name_web: "Vue Calendar",
		description:
			"Vue Calendar was a test for an application, that I was develop in my job where we need implement a calendar ",
		img: "https://pixabay.com/get/gcf815c1f8b42ee234be5093e62d868bf64f77f98996580a63a7e748396d9c431efb6088a299c5088d52218b830e900e7f6857cbeb1a5b00de5740edd4ed1bfcf_1280.png",
		code: "https://github.com/JoseCortez1/calendar-with-vue",
		website: "https://calendar-with-vue.netlify.app/",
		tags: [
			{
				name: "VueJS",
				url: "vue.svg",
				alt: "Vuejs icon",
				url: "https://cdn.svgporn.com/logos/vue.svg",
			},
			{
				name: "Vuetify",
				url: "css-3_official.svg",
				alt: "Vuetify icon",
				url: "https://cdn.svgporn.com/logos/vuetifyjs.svg",
			},
			{
				name: "Firebase",
				img: "firebase.svg",
				alt: "Firebase icon",
				url: "https://cdn.svgporn.com/logos/firebase.svg",
			},
		],
		id: 4,
	},
	{
		name_web: "Whatsapp Clone",
		description: "This is a project",
		img: "https://pixabay.com/get/gba3a1e00b5ead0daece40b41f326723a17eb7b48ad01c0d58aff20e40aeaa8aa8a047cc55f936ccc6f5506713b167619b08d08467ad39ff2dd96e5a7922ffc57_1280.png",
		website: "https://whatsapp-clone-jevc.netlify.app/",
		code: "https://github.com/JoseCortez1/whatsapp-clone",
		tags: [
			{
				name: "ReactJs",
				img: "https://cdn.svgporn.com/logos/react.svg",
				alt: "ReactJs icon",
				url: "https://cdn.svgporn.com/logos/react.svg",
			},
			{
				name: "CSS",
				img: "https://cdn-icons-png.flaticon.com/512/5968/5968242.png",
				alt: "CSS icon",
				url: "https://cdn.svgporn.com/logos/css-3.svg",
			},
			{
				name: "NodeJS",
				img: "nodejs.svg",
				alt: "NodeJS icon",
				url: "https://cdn.svgporn.com/logos/nodejs-icon.svg",
			},
			{
				name: "PusherJS",
				img: "npm.svg",
				alt: "Node icon",
				url: "https://cdn.svgporn.com/logos/pusher-icon.svg",
			},
		],
		id: 5,
	},
];
